import React from 'react';
import { useParams } from 'react-router-dom';
import TrainingWorkspace from '../components/TrainingWorkspace';

const VideoPlayer: React.FC = () => {
  const { videoId } = useParams();
  return <TrainingWorkspace primaryKind="video" primaryId={videoId} />;
};

export default VideoPlayer;
